import {
  Avatar,
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
} from "antd";
import { Rule } from "antd/lib/form";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";

import { todoApi } from "api/todo.api";
import { debounce } from "lodash";
import dayjs from "utils/dayjs";
import React, { useCallback, useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { QueryParam } from "types/query";

import { Todo } from "types/todo";
const rules: Rule[] = [{ required: true }];

export const AddTaskModal = ({
  visible,
  shopId,
  status,
  selectedTask,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  shopId?: number;
  status: ModalStatus;
  selectedTask?: Todo;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && selectedTask) {
      const { expiredAt, ...data } = selectedTask;
      form.setFieldsValue({
        ...data,
      });

      if (expiredAt) {
        form.setFieldsValue({ date: dayjs.unix(expiredAt) });
      }
    }
  }, [visible, selectedTask]);

  useEffect(() => {
    if (status == "create") form.resetFields();
  }, [status]);

  const handleSubmitForm = async () => {
    await form.validateFields();
    setLoading(true);
    const { date, content } = form.getFieldsValue();
    const dataPost = {
      todo: {
        content,
        expiredAt: date && date.endOf("day").unix(),
      },
      shopId,
    };
    try {
      switch (status) {
        case "update":
          await todoApi.update(selectedTask?.id || 0, { ...dataPost });
          message.success("Update task successfully");
          break;

        //create
        default:
          await todoApi.create({ ...dataPost });
          message.success("Add new task successfully");
          break;
      }

      onSubmitOk();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={(status == "create" ? "Thêm" : "Cập nhật") + " công việc"}
      confirmLoading={loading}
      onOk={handleSubmitForm}
    >
      <Form form={form} layout="vertical">
        <FormItem label="Hạn chót" tooltip={"Có thể để trống"} name={"date"}>
          <DatePicker
            format={"DD/MM/YYYY"}
            style={{ width: "100%" }}
            // disabledDate={(current) => {
            //   let customDate = dayjs().format("YYYY-MM-DD");
            //   return current && current < dayjs(customDate, "YYYY-MM-DD");
            // }}
          />
        </FormItem>

        <FormItem rules={rules} required label="Nội dung" name={"content"}>
          <Input.TextArea rows={5} />
        </FormItem>
      </Form>
    </Modal>)
  );
};
